import { render, staticRenderFns } from "./InFrame.vue?vue&type=template&id=67efde30&scoped=true"
import script from "./InFrame.vue?vue&type=script&lang=js"
export * from "./InFrame.vue?vue&type=script&lang=js"
import style0 from "./InFrame.vue?vue&type=style&index=0&id=67efde30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67efde30",
  null
  
)

export default component.exports